import { Drawer, DrawerProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSettings } from 'hooks/useSettings';
import LogoBar from './LogoBar';
import SocialsBar from './SocialsBar';
import ToolBar from './ToolBar';

interface StyledHeaderProps extends DrawerProps {
    open?: boolean;
    drawerHeight?: number;
}

const StyledHeader = styled(Drawer, {
    shouldForwardProp: (prop) => prop !== 'drawerHeight' && prop !== 'open'
})<StyledHeaderProps>(({ theme, open, drawerHeight }) => ({
    height: 'fit-content',
    flexShrink: 0,
    translateY: 0,
    visibility: 'visible',
    boxSizing: 'border-box',
    '& .MuiDrawer-paper': {
        height: 'fit-content',
        overflow: 'hidden',
        transform: 'none !important',
        visibility: 'visible !important',
        backgroundColor: theme.palette.background.paper,
        transition: theme.transitions.create('height', {
            easing: theme.transitions.easing.sharp,
            duration: open ? theme.transitions.duration.leavingScreen : theme.transitions.duration.enteringScreen
        })
    },
    transition: theme.transitions.create('height', {
        easing: theme.transitions.easing.sharp,
        duration: open ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen
    })
}));

interface HeaderProps extends StyledHeaderProps {
    open: boolean;
}

const Header = (props: HeaderProps) => {
    const { open } = props;
    const { url, email, projectLogo, projectFullTitle, address, project_public_athletes, project_public_officials } = useSettings();
    const drawerHeight: number = 175;
    const buttons = [
        { label: 'Calendar', url: '/public/calendar', enabled: true },
        { label: 'Athletes', url: '/public/athletes', enabled: project_public_athletes !== 'false' },
        { label: 'Officials', url: '/public/officials', enabled: project_public_officials !== 'false' },
        { label: 'Clubs', url: '/public/clubs', enabled: true },
        { label: 'Sites', url: '/public/sites', enabled: true },
        { label: 'GoToFederation', url: url, isExternal: true, enabled: true }
    ];

    return (
        <StyledHeader open={open} drawerHeight={drawerHeight} variant="persistent" anchor="top">
            <SocialsBar open={open} email={email} />
            <LogoBar open={open} projectLogo={projectLogo} projectTitle={projectFullTitle} address={address} />
            <ToolBar open={open} projectLogo={projectLogo} federationUrl={url} buttons={buttons} />
        </StyledHeader>
    );
};

export default Header;
export type { StyledHeaderProps };
